export default "__VITE_ASSET__B6t_rBWz__"